// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/icon/index.css
// module id = 28
// module chunks = 1 2 3 4 5 6